import { createContext, FC, PropsWithChildren } from 'react'
import { QueryClient } from '@tanstack/query-core'

import { queryClient } from 'lib/queryClient'

export interface IAppProvider {
  queryClient: QueryClient
}

const appProvider: IAppProvider = {
  queryClient,
}

export const AppContext = createContext<IAppProvider>(appProvider)

export const AppProvider: FC<PropsWithChildren> = props => {
  return <AppContext.Provider value={appProvider}>{props.children}</AppContext.Provider>
}
